import React from 'react';
import PropTypes from 'prop-types';

import { Route, Redirect } from 'react-router-dom';

import { useSelector } from 'react-redux';
import { store } from '~/store';
import DefaultLayout from '~/pages/layouts/app';
import AuthLayout from '~/pages/layouts/auth';

// console.log(AppLayout);

export default function RouteWrapper({
  component: Component,
  isPrivate,
  ...rest
}) {
  const { signed } = store.getState().auth;

  const isSigned = useSelector((state) => state.auth.signed);

  // console.log('Is Signed', isSigned);

  if (!isSigned && isPrivate) {
    return <Redirect to="/" />;
  }

  if (isSigned && !isPrivate) {
    return <Redirect to="/dashboard" />;
  }

  const Layout = isSigned ? DefaultLayout : AuthLayout;

  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout>
          <Component {...props} />
        </Layout>
      )}
    />
  );
}

RouteWrapper.propTypes = {
  isPrivate: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
};

RouteWrapper.defaultProps = {
  isPrivate: false,
};
